module.exports = __webpack_public_path__ + "static/img/tu.35e6146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu.png
// module id = KodM
// module chunks = 1